export default __webpack_public_path__ + "static/media/lock.54632536.png";